import VideoThumbnail from "./VideoThumbnail";
import AudioPlayer from "./AudioPlayer";
import CircleSpinner from "../CircleSpinner";
import Icon from "../Icon";
import { MessageAttachments } from "../../types";

interface AttachmentItemProps {
  item: MessageAttachments;
  index: number;
  openCarousel: (index?: number) => void;
  color: "white" | "primary" | "negative" | "success" | "info" | undefined;
}

const AttachmentItem: React.FC<AttachmentItemProps> = ({ item, index, openCarousel, color }) => {
  const isImageOrVideo = (mimeType: string) => mimeType.startsWith("image/") || mimeType.startsWith("video/");
  const isAudio = (mimeType: string) => mimeType.startsWith("audio/ogg");

  if (item.relative_path && !item.is_fetching && isImageOrVideo(item.file_mime_type)) {
    return (
      <div
        key={item.id}
        className="hover:shadow-lg"
        style={{
          margin: "5px",
          borderRadius: "8px",
          overflow: "hidden",
          cursor: "pointer",
        }}
        onClick={() => openCarousel(index)}
      >
        {item.file_mime_type.startsWith("video") ? (
          <VideoThumbnail src={item.relative_path} alt={item.file_name} />
        ) : (
          <img
            src={item.relative_path}
            alt={item.file_name}
            style={{ width: "100%", height: "auto", borderRadius: "8px" }}
          />
        )}
      </div>
    );
  }

  if (item.relative_path && !item.is_fetching && isAudio(item.file_mime_type)) {
    return (
      <div key={item.id} style={{ overflow: "hidden" }}>
        <div style={{ textAlign: "center" }}>
          {item.is_fetching ? <CircleSpinner color={color} /> : item.blob? <AudioPlayer audioBlob={item.blob} />: <></>}
        </div>
      </div>
    );
  }

  return (
    <div key={item.id} className="hover:shadow-lg" style={{ margin: "5px", borderRadius: "8px", overflow: "hidden" }}>
      <div style={{ textAlign: "center" }}>
        {item.is_fetching ? (
          <CircleSpinner color={color} />
        ) : (
          <a
            href={item.relative_path}
            download
            style={{
              display: "inline-block",
              padding: "8px",
              backgroundColor: "whitesmoke",
              borderRadius: "4px",
              textDecoration: "none",
            }}
          >
            <Icon name={item.file_mime_type} size="80px" />
          </a>
        )}
      </div>
    </div>
  );
};

export default AttachmentItem;
